import { css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { getInputValueAsNumber } from "./DMSToDecimalDegrees";
import { watch } from "./internal/watch";
import { makeCustomEvent } from "../Utils";
import { makeLocation } from "../models/ILocation";

@customElement("ds-decimal-degrees-input")
export class DecimalDegreesInput extends BaseElement {
    static override styles = [Style, css``];

    @state() protected _lat: number | undefined;
    @state() protected _lon: number | undefined;

    public reset() {
        this._lat = this._lon = undefined;
    }

    @watch("_lat")
    @watch("_lon")
    public onChanged() {
        if (this._lat && this._lon) {
            this.dispatchEvent(
                makeCustomEvent("ds-changed", {
                    location: makeLocation(this._lat, this._lon),
                })
            );
        } else {
            this.dispatchEvent(makeCustomEvent("ds-error"));
        }
    }

    override render() {
        return html`<div class="flex-column">
            <sl-input
                type="number"
                label="Latitude"
                .value=${this._lat?.toString() ?? ""}
                @sl-input=${(e: Event) => {
                    this._lat = getInputValueAsNumber(e.target as HTMLInputElement);
                }}
            ></sl-input>
            <sl-input
                type="number"
                label="Longitude"
                .value=${this._lon?.toString() ?? ""}
                @sl-input=${(e: Event) => {
                    this._lon = getInputValueAsNumber(e.target as HTMLInputElement);
                }}
            ></sl-input>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-decimal-degrees-input": DecimalDegreesInput;
    }
}
